// COMPONENTS
import BalanceTooltip from "src/components/wallets/header/BalanceTooltip";
import { SwapIconWrapper } from "./SwapCard";

// HOOKS
import useTradeUI from "../hooks/useTradeUI";

// ICONS
import { SwitchArrows } from "src/icons/SwitchIcon";

// CONSTANTS
import { SWITCH_TOOLTIP } from "../../constants";

export const OrderSwitch = () => {
  const { clearButton, hasInputsSwapped, handleTradeInputSwap } = useTradeUI({});

  return (
    <BalanceTooltip message={SWITCH_TOOLTIP} contrast>
      <SwapIconWrapper
        clicked={hasInputsSwapped}
        disable={clearButton.isLoading}
        onClick={handleTradeInputSwap}>
        <SwitchArrows />
      </SwapIconWrapper>
    </BalanceTooltip>
  );
};
